module.exports = __webpack_public_path__ + "static/img/logo.f2291eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/regioner/SE2321000016/logo.svg
// module id = 16fu
// module chunks = 1